// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Client meetings list. Root: .client-meetings */
.client-meetings {
  padding: var(--ds-page-pad);
}

/* Inside the panel shell the content area already has page padding. */
.app-content .client-meetings {
  padding: 0;
}

.client-meetings__title {
  margin: 0 0 var(--ds-space-4);
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
}
`, "",{"version":3,"sources":["webpack://./src/meetings-only/Meetings.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,2BAA2B;AAC7B;;AAEA,sEAAsE;AACtE;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Client meetings list. Root: .client-meetings */\n.client-meetings {\n  padding: var(--ds-page-pad);\n}\n\n/* Inside the panel shell the content area already has page padding. */\n.app-content .client-meetings {\n  padding: 0;\n}\n\n.client-meetings__title {\n  margin: 0 0 var(--ds-space-4);\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
